import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {IntervalOption} from '../../../../../model/dataset/rendering/interval-option';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {ColorUtils} from '../../../../../core/utils/color-utils';
import {NotifService} from '../../../../../core/notification/notif.service';

const NUMBER_INPUT_MAX = 100000000000;

@Component({
    selector: 'mpt-color-intervals',
    templateUrl: './color-intervals.component.html',
    styleUrls: ['./color-intervals.component.scss']
})
export class ColorIntervalsComponent implements OnInit, OnChanges {

    @Input() intervals: IntervalOption[];
    @Output() Update: EventEmitter<any> = new EventEmitter<any>();
    intervalForm: UntypedFormGroup;
    color: string = '#000000';
    constructor(private readonly formBuilder: UntypedFormBuilder, private readonly notifService: NotifService) {
    }

    ngOnInit(): void {
        this.initForm();
        this.cleanupCorruptedIntervals();
    }

    ngOnChanges(): void {
        // Clean up whenever intervals input changes
        this.cleanupCorruptedIntervals();
    }

    private cleanupCorruptedIntervals(): void {
        // Remove any point intervals [n, n] that may have been loaded from storage
        if (!this.intervals || this.intervals.length === 0) {
            return;
        }

        for (let i = this.intervals.length - 1; i >= 0; i--) {
            const interval = this.intervals[i];
            if (interval.minValue != null && interval.maxValue != null) {
                const min = Number(interval.minValue);
                const max = Number(interval.maxValue);
                if (min === max) {
                    this.intervals.splice(i, 1);
                }
            }
        }
    }

    addInterval(interval?: IntervalOption) {

        let minValue = this.intervalForm.controls.minValue.value;
        let maxValue = this.intervalForm.controls.maxValue.value;
        let color = this.intervalForm.controls.color.value;
        if (minValue > maxValue && maxValue !== null) {
            this.notifService.error('Min cannot be greater than max.');
            return;
        }

        if (minValue > NUMBER_INPUT_MAX || maxValue > NUMBER_INPUT_MAX) {
            this.notifService.error('Exceeded the maximum allowed.');
            return;
        }

        // Check for point intervals [n, n] which are invalid
        if (minValue !== null && maxValue !== null && Number(minValue) === Number(maxValue)) {
            this.notifService.error('Min and max values cannot be the same (point intervals are invalid).');
            return;
        }

        const editedInterval = interval;
        const intervals = this.intervals;

        if (editedInterval === undefined) {
            if (this.intervalForm.valid) {
                intervals.push({color: ColorUtils.colorFromBase64(color), minValue: minValue, maxValue: maxValue, total: maxValue});
            }
        } else {
            return;
        }
    }

    get ColorUtils() {
        return ColorUtils;
    }

    private initForm() {
        this.intervalForm = this.formBuilder.group({
            color: ['#aaaaaa', [Validators.required]],
            minValue: [0, [Validators.required]],
            maxValue: [],
        });
    }

    toggleEdit(interval: IntervalOption) {
        if (interval.minValue > interval.maxValue && interval.maxValue !== null) {
            interval.maxValue = null;
            interval.minValue = 0;
            this.notifService.error('Min cannot be greater then max.');
            return;
        }

        if (interval.minValue > NUMBER_INPUT_MAX || interval.maxValue > NUMBER_INPUT_MAX) {
            interval.maxValue = null;
            interval.minValue = 0;
            this.notifService.error('Exceeded the maximum allowed.');
        }
        interval.edit = !interval.edit;
        if (interval.edit === false) {
            this.addInterval(interval);
        }
    }

    applyIntervals() {
        this.intervals.forEach((searchedInterval) => {
            searchedInterval.edit = false;
        });
    }

    saveColor($event, interval?: IntervalOption) {
        let int = this.intervals.find((searchedInterval) => {
            return searchedInterval === interval;
        });
        int.color = ColorUtils.colorFromBase64($event);
        this.color = $event;
    }

    removeInterval(interval) {
        if(this.intervals.length===1) {
            return;
        }
        this.intervals.splice(this.intervals.indexOf(interval), 1);
    }
}
